import { render } from "./PenyediaanModal.vue?vue&type=template&id=ff899344&ts=true"
import script from "./PenyediaanModal.vue?vue&type=script&lang=ts"
export * from "./PenyediaanModal.vue?vue&type=script&lang=ts"

import "./PenyediaanModal.vue?vue&type=style&index=0&id=ff899344&lang=scss"

import exportComponent from "/home/vendor/oesb/ispk-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__